/**
 * Contrôle d'accès à l'ÉDITION d'un exercice côté UI.
 *
 * Miroir de la RLS `exercises: author_update` (migration 0004) :
 * `is_admin() OR created_by = auth.uid()`. Un exercice publié d'un AUTRE auteur
 * (désormais atteignable via la recherche globale `search_exercises`, migration
 * 0181) doit être en LECTURE SEULE : on masque toutes les actions mutantes
 * (modifier / publier / dupliquer / archiver / supprimer). Le serveur (RLS)
 * reste la garde ultime — ceci n'est qu'un miroir pour l'expérience.
 */
export function canEditExercise(
  createdBy: string | null | undefined,
  userId: string | null | undefined,
  isAdminUser: boolean,
): boolean {
  return isAdminUser || (!!createdBy && !!userId && createdBy === userId);
}
